import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { KeyLabelType } from '~/types'
import ManureFields from './GreenhouseGas/ManureFields'
import InfoPopup from '~/components/InfoPopup'

interface Props {
  manureTypes: KeyLabelType[]
  manureStorageTypes: any[]
}

const Services: React.FC<Props> = ({ manureTypes, manureStorageTypes }) => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()

  const watchManureType = useWatch({ control, name: 'manureType' })

  useEffect(() => {
    if (watchManureType !== 1) {
      setValue('manureStorageTypes', [])
    }
  }, [watchManureType])

  return (
    <>
      <Form.Group widths={'equal'} style={{ marginBottom: '2em' }}>
        <FormFields.Select
          control={control}
          withoutAsterisk
          name={'manureType'}
          label={<label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div>{t('Main type of farm fertilizer')}</div>
            <InfoPopup
              content={t('Currently only one type of farm fertilizer can be calculated. Therefore, please indicate the main species.')}
              styleIcon={{ fontSize: '1.2em' }}
              position={'top center'}
            />
          </label>}
          rules={{
            required: true
          }}
          noErrorMessage
          placeholder={t('Please select')}
          options={manureTypes?.map(breedOption => ({ value: breedOption.key, text: breedOption.label }))}
        />
        <FormFields.Input
          control={control}
          typeInput='controled'
          allowDecimals={false}
          rules={{
            min: 0,
            max: 365,
            required: true
          }}
          withoutAsterisk
          noErrorMessage
          suffix=' Weidetage pro Kuh und Jahr'
          name={'pastureDays'}
          label={<label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div>{t('Number of grazing days')}</div>
            <InfoPopup
              content={t('Affects the amount of fertilizer produced in the stable. Please note that this value represents an average of all dairy cows')}
              styleIcon={{ fontSize: '1.2em' }}
              position={'top center'}
            />
          </label>}
          placeholder={t('Number of grazing days')}
        />
        <FormFields.Input
          control={control}
          name={'litterQuantity'}
          decimalScale={2}
          noErrorMessage
          rules={{
            validate: (value) => {
              const transformValue = typeof (value) === 'string' ? parseFloat(value.replace(',', '.')) : value
              if (transformValue < 0 || transformValue > 25) {
                return false
              }
              return true
            },
            required: true
          }}
          allowDecimals
          label={<label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div>{t('Amount of bedding')}</div>
            <InfoPopup
              content={t('Total amount of bedding used for the cows (excluding offspring).')}
              styleIcon={{ fontSize: '1.2em' }}
              position={'top center'}
            />
          </label>}
          withoutAsterisk
          typeInput={'controled'}
          suffix=' dt/pro Kuh und Jahr'
          placeholder={t('Amount of bedding')}
        />
      </Form.Group>
      {watchManureType === 1 && <ManureFields
        options={manureStorageTypes}
      />
      }
    </>
  );
}
export default Services